export default __webpack_public_path__ + "static/media/panelData1.8e087b55.png";